module.exports = __webpack_public_path__ + "static/media/sydney_swans.36f447a.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/sydney_swans.mp3
// module id = tVW7
// module chunks = 0